import {Stack} from "@mui/material";
import CategoryItemV3UI from "../../../mock-test-category/components/CategoryItemV3UI";
import {
  getQuestionCategoryItemList,
  getQuestionCategoryType,
} from "../../data/question-category-data";

interface QuestionCategoryFilterMainProps {
  selectedCategory?: string;
  handleCategoryClick: (id: any) => void;
}

export default function QuestionCategoryFilterMain({
  selectedCategory = "",
  handleCategoryClick,
}: QuestionCategoryFilterMainProps) {
  const category = getQuestionCategoryType(selectedCategory);
  const data = getQuestionCategoryItemList(category);

  return (
    <Stack direction="row" spacing={1.5}>
      {data.map(item => (
        <CategoryItemV3UI
          key={item.id}
          {...item}
          onClick={handleCategoryClick}
        />
      ))}
    </Stack>
  );
}
